export const Contact = () => (
  <section className="section contact" id="contact" data-testid="contact-section">
    <div className="section-heading" data-testid="contact-heading">
      <h2 data-testid="contact-title">Let's start the conversation</h2>
      <p data-testid="contact-subtitle">
        Tell us which world you belong to, leader, student or professional,
        and we will build the right plan for you.
      </p>
    </div>
    <div className="contact-grid" data-testid="contact-grid">
      <div className="contact-card" data-testid="contact-cta-card">
        <span className="contact-card-kicker" data-testid="contact-cta-kicker">
          Book a strategy call
        </span>
        <h3 data-testid="contact-cta-heading">Let's map your Vartalab plan</h3>
        <p data-testid="contact-cta-description">
          Reserve a free consultation and we will outline the content, design
          and distribution plan built for your world.
        </p>
        <a
          className="cta-button large calendly-button"
          href="https://calendly.com/kiranwritesyougrow/30min"
          target="_blank"
          rel="noreferrer"
          data-testid="contact-calendly-button"
        >
          Book A Free Consultation Call Now
        </a>
        <span className="contact-note" data-testid="contact-cta-note">
          Instant confirmation by email. Limited slots every week.
        </span>
      </div>
      <div className="contact-info" data-testid="contact-info">
        <div className="info-card highlight" data-testid="contact-info-card">
          <h3 data-testid="contact-info-title">What happens next</h3>
          <ul data-testid="contact-info-list">
            <li data-testid="contact-info-item-one">
              We learn which pillar fits you, leader, student or professional.
            </li>
            <li data-testid="contact-info-item-two">
              You get a short strategy call with a senior member of our team.
            </li>
            <li data-testid="contact-info-item-three">
              We share a clear plan for content, design and distribution
              going forward.
            </li>
          </ul>
        </div>
        <div className="contact-cta" data-testid="contact-cta-block">
          <h4 data-testid="contact-cta-title">Prefer a direct call?</h4>
          <p data-testid="contact-cta-text">
            Call us at +91 7350940448 and we will send calendar options
            within a day.
          </p>
        </div>
      </div>
    </div>
  </section>
);
